export const INITIAL_STREAM_DELAY_MS = 100;
export const BLOCK_TRANSITION_DELAY_MS = 50;
export const DEFAULT_CHUNK_SIZE = 4;
export const IMMEDIATE_TIMEOUT_MS = 0;
export const STREAM_DEMO_CHUNK_DELAY_MS = 20;
export const STREAM_DEMO_BLOCK_DELAY_MS = 400;
export const STREAM_DEMO_PRELOAD_ANIMATION_DELAY_MULTIPLIER = 0.03;
export const GREP_SEARCH_DELAY_MS = 400;

export const BENCHMARK_CONTROL_COLOR = "#525252";
export const BENCHMARK_TREATMENT_COLOR = "#ff4fff";
export const BENCHMARK_TOOLTIP_CONTROL_SECONDS = 16.8;
export const BENCHMARK_TOOLTIP_TREATMENT_SECONDS = 5.8;
export const BENCHMARK_TOOLTIP_MAX_SECONDS = 20;
export const BENCHMARK_TOOLTIP_SPEEDUP_FACTOR = "3";

export const CLICK_FEEDBACK_DURATION_MS = 300;
export const COPY_FEEDBACK_DURATION_MS = 1200;
export const TOOLTIP_HOVER_DELAY_MS = 150;
export const HOTKEY_KEYUP_DELAY_MS = 150;
export const ACTIVATION_POLL_INTERVAL_MS = 100;
export const PROMPT_INSTALL_COLLAPSE_LINE_THRESHOLD = 12;
export const PROMPT_INSTALL_MAX_HEIGHT_PX = 260;
export const AGENT_CYCLE_INTERVAL_MS = 3000;

export const VIBRATION_DURATION_MS = 100;
export const TAP_FEEDBACK_DISPLAY_MS = 800;
export const TAP_FEEDBACK_FADE_MS = 300;
export const LABEL_OFFSET_BELOW_PX = 10;
export const ANIMATION_RESTART_DELAY_MS = 200;
export const SELECTION_PADDING_PX = 4;
export const CURSOR_OFFSET_PX = 16;
export const HINT_OVERLAY_DELAY_MS = 3000;
export const IDLE_RESTART_DELAY_MS = 5000;
